import { render } from "./InlineVideo.vue?vue&type=template&id=b4005352&scoped=true&ts=true"
import script from "./InlineVideo.vue?vue&type=script&lang=ts"
export * from "./InlineVideo.vue?vue&type=script&lang=ts"

import "./InlineVideo.vue?vue&type=style&index=0&id=b4005352&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4005352"]])

export default __exports__